import React from 'react';
import styled from 'styled-components';
import TopBar from './components/Topbar';
import Footer from './components/Footer';
import PageLoader from 'components/PageLoader';
import SuspenseWithChunkError from 'components/SuspenseWithChunkError';
import { useGetLikedNFT } from 'state/nft/hooks';
import BottomBar from './components/Bottombar';
import { fetchHunnyPrice } from 'state/app';

const MainLayout: React.FC = ({ children }) => {
	return (
		<StyledWraper>
			<DataWorker />
			<StyledBackground />
			<TopBar />
			<StyledContent>
				<SuspenseWithChunkError fallback={<PageLoader />}>{children}</SuspenseWithChunkError>
			</StyledContent>
			<BottomBar />
			<Footer />
		</StyledWraper>
	);
};

const DataWorker: React.FC = () => {
	/// Get list NFT Item Id
	useGetLikedNFT();

	return null;
};

const StyledWraper = styled.div`
	height: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	overflow-x: hidden;
`;

const StyledContent = styled.div`
	display: flex;
	flex: 1;
	padding-top: 80px;

	@media (max-width: 590px) {
		padding-top: 60px;
	}
`;

const StyledBackground = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: -1;
	width: 100vw;
	height: 100vh;
	background-position: 0px -30vh;
	background-repeat: no-repeat;
	background-image: radial-gradient(
		50% 50% at 50% 50%,
		rgba(33, 114, 229, 0.1) 0%,
		rgba(33, 36, 41, 0) 100%
	);
`;

export default MainLayout;
